import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "content"]
  static values = {
    hideDelay: { type: Number, default: 200 }
  }

  connect() {
    this.hideTimeout = null
  }

  disconnect() {
    this.clearHideTimeout()
  }

  show() {
    this.clearHideTimeout()

    if (!this.hasContentTarget) return

    const content = this.contentTarget.innerHTML
    if (!content) return

    // 既に表示されている場合は何もしない
    if (this.hasCardTarget) return

    const fragment = document.createRange().createContextualFragment(content)
    this.element.appendChild(fragment)
  }

  hide() {
    this.clearHideTimeout()

    this.hideTimeout = setTimeout(() => {
      if (this.hasCardTarget) {
        this.cardTarget.remove()
      }
    }, this.hideDelayValue)
  }

  clearHideTimeout() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
  }
}
